// Contenu de assets/pubsub.js MODIFIÉ
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }
  subscribers[eventName] = [...subscribers[eventName], callback];
  console.log(`[PubSub] New subscription for event: ${eventName}. Total subscribers: ${subscribers[eventName].length}`); // Log ajouté
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName] && subscribers[eventName].length > 0) { // Vérifie aussi qu'il y a au moins un abonné
    console.log(`[PubSub] Publishing event: ${eventName} to ${subscribers[eventName].length} subscriber(s). Data:`, data); // Log modifié
    subscribers[eventName].forEach((callback) => {
      try { // Ajout d'un try-catch au cas où le callback lui-même aurait une erreur
        callback(data);
      } catch (e) {
        console.error(`[PubSub] Error in callback for event ${eventName}:`, e);
      }
    });
  } else {
    console.log(`[PubSub] No subscribers for event: ${eventName} when trying to publish. Data was:`, data); // Log modifié/ajouté
  }
}